import React from "react";

import DeleteGraySvg from "../../assets/images/icons/delete_gray.svg";

export const DeleteGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={DeleteGraySvg}
        alt={alt || "Delete"}
    />
);
